import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import moment from "moment/moment";
import formsActionCreators from "../../store/forms/action-creators";
import ReactTooltip from 'react-tooltip'
import {Input} from "reactstrap";
import classNames from 'classnames';
import {Auth} from "../../../shared/services/aws";

class PrintForms extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedFormStatus: 'current',
      authToken: ''
    }
  }

  componentWillMount() {
    this.props.fetchForms();
    Auth.currentSession()
      .then(res => {
        this.setState({
          authToken: res.accessToken.jwtToken
        })
      })
  }

  setFormStatus(formStatus) {
    this.setState({
      selectedFormStatus: formStatus
    })
  }

  get filteredForms() {
    return !!this.state.selectedFormStatus && this.props.forms
      ? this.props.forms.filter(f => f.status === this.state.selectedFormStatus)
      : this.props.forms;
  }

  render() {
    return !this.isLoading && (
      <Fragment>
        <div className="app-content-header">
          <h4 className="title">Forms</h4>
        </div>
        <div className="app-content">

          <div className="form form-inline">
            <div className="form-group" style={{flex: 0.3}}>
              <Input
                name="type"
                onChange={event =>
                  this.setFormStatus(event.target.value)
                }
                type="select"
                value={this.state.selectedFormStatus}
              >
                <option value={''}>{this.state.selectedFormStatus ? 'Show all': 'Select status'}</option>
                <option value="draft">Draft</option>
                <option value="current">Current</option>
                <option value="revised">Revised</option>
              </Input>
            </div>
          </div>

          <div className="table-scrollable">
            <table className="table table-striped">
              <thead>
              <tr>
                <th>
                  <div className="header">
                    <span>Type </span>
                  </div>
                </th>
                <th>
                  <div className="header">
                    <span>Status </span>
                  </div>
                </th>

                <th>
                  <div className="header">
                    <span>Updated at </span>
                  </div>
                </th>
                <th>
                  <div className="header">
                    <span>Actions </span>
                  </div>
                </th>

              </tr>
              </thead>

              <tbody>
              {this.filteredForms && this.filteredForms.map((form, index) => (
                <tr key={index.toString()}>
                  <td> {form.name} </td>
                  <td>
                  <span className={classNames('badge', {
                    'badge-primary': form.status === 'revised',
                    'badge-secondary': form.status === 'draft',
                    'badge-success': form.status === 'current'
                  })}>
                  {form.getCapitalized('status')}
                  </span>
                  </td>
                  <td> {moment(form.updatedAt).format('MMM D, YYYY')} </td>
                  <td>
                    <div className="td-actions">
                      <ReactTooltip place="top" className='customTheme' effect="solid"/>
                      <a
                        className="button small default"
                        data-tip="Download blank form"
                        href={`/api/v1/forms/${form.guid}/pdf/${this.state.authToken}`} download={`${form.name}.pdf`}>
                        <i className="fa fa-print"/>
                      </a>
                    </div>
                  </td>
                </tr>

              ))}
              </tbody>
            </table>
          </div>


        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    forms: state.forms.list,
    isLoading: !!state.forms.isLoading.length,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchForms: () => {
      return dispatch(formsActionCreators.fetchForms());
    },
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrintForms);
